import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { Table, Column, Button, Input, RecordSelect, Checkbox } from '@smartplatform/ui';
import { fio } from './tools';
import store from '../../store';
import empty from '../../../site/img/user.png';

const PHOTO_SIZE = 30;

@observer
export default class List extends React.Component {
	@observable records = [];
	@observable newRecords = [];
	@observable showNewRecords = false;
	@observable search = '';
	@observable convocation = null;
	@observable isLoading = false;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		const convocations = await store.model.Convocation.find({
			where: { current: true },
		});
		this.convocation = convocations.length > 0 ? convocations[0] : null;
		await this.loadDeputies();
	};

	@action loadDeputies = async () => {
		this.isLoading = true;
		this.records = [];
		const where = { and: [] };
		if (this.convocation) where.and.push({ convocationId: this.convocation.id });

		const allRecords = await store.model.Deputy.find({
			include: [{ relation: 'depConv', scope: { fields: { id: true } } }],
			fields: { id: true, lastName: true, firstName: true, middleName: true, photo: true },
		});

		this.newRecords = allRecords.filter(d => d.depConv().length === 0);
		// console.log('newRecords', this.newRecords.map(fio));

		this.records = await store.model.DeputyConvocation.find({
			where,
			include: [
				{
					relation: 'deputy',
					scope: {
						include: [
							{ relation: 'convocations', scope: { fields: { id: true, name: true }, order: 'id asc' } },
						],
					},
				},
				{ relation: 'fraction', scope: { fields: { id: true, shortName: true } } },
				{ relation: 'division', scope: { fields: { id: true, name: true } } },
				{ relation: 'divisionGroup', scope: { fields: { id: true, name: true } } },
			],
		});

		this.isLoading = false;
	};

	create = () => this.props.history.push('/admin/deputies/create');

	photo = deputy =>
		deputy.photo ? (
			<img
				src={deputy.downloadFile('photo')}
				width={PHOTO_SIZE}
				height={PHOTO_SIZE}
				style={{ objectFit: 'cover' }}
			/>
		) : (
			<img src={empty} width={PHOTO_SIZE} height={PHOTO_SIZE} style={{ objectFit: 'cover' }} />
		);

	convocations = deputy =>
		deputy
			.convocations()
			.map(convocation => convocation.name)
			.join(', ');

	division = depConv =>
		depConv.divisionGroup
			? depConv.divisionGroup.name
			: depConv.division
			? `${depConv.division.name} №${depConv.division.number}`
			: depConv.divisionText || '';

	onConvChange = async conv => {
		this.convocation = conv;
		await this.loadDeputies();
	};

	gotoDeputy = devConv => this.props.history.push(`/admin/deputies/${devConv.deputyId}`);

	onSearch = e => {
		this.search = e.target.value;
		// console.log('onSearch', this.search);
		// this.doSearch();
	};

	doSearch = async () => {
		await this.loadDeputies();
	};

	render() {
		let depConv = this.records
			.filter(dc => !!dc.deputy)
			.sort((a, b) => {
				if (a.deputy.lastName > b.deputy.lastName) return 1;
				if (a.deputy.lastName < b.deputy.lastName) return -1;
				return 0;
			});

		const trimmed = this.search.trim();
		if (trimmed.length) {
			depConv = depConv.filter(dc => {
				const r = new RegExp(`^${trimmed}`, 'i');
				return r.test(dc.deputy.lastName) || r.test(dc.deputy.firstName) || r.test(dc.deputy.middleName);
			});
		}

		const content = (
			<>
				{this.showNewRecords && (
					<>
						<Table records={this.newRecords} rootPath="/admin">
							<Column width={PHOTO_SIZE} className="photo" computed={this.photo} />
							<Column width={300} label="Ф.И.О." computed={fio} />
							<Column width={200} />
							<Column width={120} />
							<Column />
						</Table>
					</>
				)}
				{!this.showNewRecords && depConv.length > 0 && (
					<>
						<Table records={depConv} rootPath="/admin" onRowClick={this.gotoDeputy}>
							<Column width={PHOTO_SIZE} className="photo" relation="deputy" computed={this.photo} />
							<Column width={300} label="Ф.И.О." relation="deputy" computed={fio} />
							<Column width={200} label="Созывы" relation="deputy" computed={this.convocations} />
							<Column width={120} relation="fraction" property="shortName" label="Фракция" />
							<Column label="Избирательный округ / группа" computed={this.division} />
							<Column
								width={120}
								style={{ fontWeight: 600 }}
								property="endDate"
								label="Конец полномочий"
							/>
							<Column width={120} relation="deputy" property="appointment" label="Запись на прием" />
							<Column width={120} relation="deputy" property="appointmentDates" label="Даты приема" />
						</Table>
					</>
				)}
			</>
		);

		return (
			<div className="deputies-list">
				<p>Депутаты</p>
				<p>
					<Button className="btn-primary" onClick={this.create}>
						Создать
					</Button>
				</p>
				<div className="filters">
					<RecordSelect
						model={store.model.Convocation}
						value={this.convocation}
						property="name"
						onChange={this.onConvChange}
						isRequired={true}
						disabled={this.showNewRecords}
						filter={{ order: 'id desc' }}
					/>
					<Input
						value={this.search}
						onChange={this.onSearch}
						placeholder="Поиск по Ф.И.О."
						disabled={this.showNewRecords}
					/>
					<Checkbox value={this.showNewRecords} onChange={value => (this.showNewRecords = value)} /> Показать
					депутатов без созыва ({this.newRecords.length})
				</div>
				<div className={this.isLoading ? 'is-loading' : ''}>{content}</div>
			</div>
		);
	}
}
